import React, { useEffect } from "react";
import TopLeft from "../../assets/images/expression-blue 1.png";
import TopRight from "../../assets/images/expression-pink 1.png";
import BottomLeft from "../../assets/images/expression-pink 3.png";
import BottomRight from "../../assets/images/expression-green 1.png";
import CenterImg from "../../assets/images/Group 48.png";
import "./LandingScreen.css";
import { useNavigate } from "react-router-dom";

let imagesArray = [
  {
    imgSrc: TopLeft,
    position: "topLeft",
  },
  {
    imgSrc: TopRight,
    position: "topRight",
  },
  {
    imgSrc: BottomLeft,
    position: "bottomLeft",
  },
  {
    imgSrc: BottomRight,
    position: "bottomRight",
  },
];
function LandingScreen() {
  const navigate = useNavigate();

  //Handle landscreen click
  let handleLandScreenClick = () => {
    navigate("/login");
  };

  useEffect(() => {
    setTimeout(() => {
      handleLandScreenClick();
    }, 5000);
  }, []);

  return (
    <div
      className="landingScreen w-full h-screen relative flex justify-center items-center"
      onClick={handleLandScreenClick}
    >
      {imagesArray.map((item, idx) => (
        <img
          className={`absolute ${item.position}`}
          src={item.imgSrc}
          key={idx}
        />
      ))}

      <img
        className="landingScreen__centerImg"
        src={CenterImg}
        onClick={handleLandScreenClick}
      />
    </div>
  );
}

export default LandingScreen;
